<!-- 人员进出管理 -->
<template>
  <div class="important_event">
    <!-- 循环电子围栏前四个 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in regionList" :key="index" :label="item.name" :name="item.name"></el-tab-pane>
    </el-tabs>
    <div class="import_num">
      <div :class="setMore ? 'more_amount' : 'least_amount'" class="amount">
        <div class="num">{{ total }}</div>
        <div class="equip_name">{{ $t('ShouldBDutyToday') }}</div>
      </div>
      <div class="amount" :class="setMore ? 'more_amount' : 'least_amount'">
        <div class="num">{{ workNumber }}</div>
        <div class="equip_name">{{ $t('ActualOnDutyToday') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { geofenceList } from '@/api/fence'
import { geoFencesNumber } from '@/api/new-person/newPerson'

export default {
  props: {
    setMore: {
      type: Boolean,
    },
    currenNode: {
      type: Object,
    },
  },
  data() {
    return {
      activeName: '',
      activeItem: {},
      // 是否到岗数据
      total: 0,
      workNumber: 0,
      // 电子围栏数据
      regionList: [],
      showMore: false,
    }
  },
  methods: {
    handleClick(tab) {
      for (let item of this.regionList) {
        if (item.name === tab.paneName) {
          this.activeItem = item
          this.getFencesNumber()
        }
      }
    },
    // 获取围栏列表
    _geofenceList() {
      //  ouId: this.currenNode.id
      let param = {}
      geofenceList(param).then(res => {
        if (res.state === 0) {
          this.regionList = res.data
          if (this.regionList.length > 0) {
            this.activeItem = this.regionList[0]
            this.activeName = this.activeItem.name
            this.getFencesNumber()
          }
          this.$emit('personelMore', this.showMore)
        }
      })
    },
    // 获取该区域到岗的情况
    getFencesNumber() {
      let param = {
        fenceId: this.activeItem.id,
        ouIds: this.activeItem.ouIds,
      }
      geoFencesNumber(param).then(res => {
        if (res.state === 0) {
          if (res.value) {
            this.total = res.value.total
            this.workNumber = res.value.workNumber
          }
        }
      })
    },
  },
  created() {},
  watch: {
    'currenNode.id': {
      immediate: true,
      handler(val) {
        this._geofenceList()
      },
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.important_event
  height: calc(100% - 40px)
  pointer-events: auto
  .import_num
    width 100%
    height: calc(100% - 40px)
    display flex
    align-items: center
    justify-content: center
    margin 0 8px
    .amount
      text-align center
      .num
        width 170px
        height 170px
        line-height 170px
        margin 0 auto
        font-size: 32px
        color: #fff
        bg-image-full('~@/icon/home/circular.png')
      .equip_name
        margin-top 10px
        color #333
        font-size: 20px
        font-weight: bold
    .more_amount
      width: 20%
      margin-top 40px
    .least_amount
      width 45%
// >>> .el-tabs__nav-scroll
//   display flex
//   justify-content: center
  >>>.el-tabs__nav-next, >>>.el-tabs__nav-prev
    font-weight: bold;
    line-height 44px!important
  >>> .el-tabs__nav
    margin-top: 10px
  >>> .el-tabs__header
    margin 0
  >>> .el-tabs__nav-wrap::after
    background-color transparent
  >>>.el-tabs__item
    font-size: 16px
    min-width 120px
    height 30px!important
    line-height 30px!important
    margin-right 10px
    text-align: center
    padding: 0 14px
    border-radius: 4px;
  >>>.el-tabs--top .el-tabs__item.is-top:nth-child(2)
    padding-left 14px
  >>> .el-tabs__nav .is-active
    text-align: center
    color #fff !important
    font-weight: bold!important
    background: #1C76DD
    font-weight: bold
  >>> .el-tabs__active-bar
    background-color transparent !important
// 深色样式
.theme-dark
  .important_event
    .import_num
      .amount
        .num
          color: #00E4FF
          bg-image-full('~@/icon/home/ic_circular.png')
        .equip_name
          color #fff
  >>>.el-tabs__nav .is-active
    background: #1C76DD
    border: 1px solid #06EEFC
  >>>.el-tabs__item
    color: #1485EE!important
    background: #0336B9!important
    border: 1px solid #1485EE!important
</style>
